import { proxy, subscribe } from "valtio"
import { deepClone } from "valtio/utils"
import type { Address } from "../types"
import { persistStore, restoreStore } from "../utils/storeUtils"

// -- Helpers -------------------------------------------------------
const STORAGE_KEY = "opensea-wallet-blur-auth-store"
const STORAGE_VERSION = 1

export function isValidToken(authInfo: BlurAuthInfo | undefined) {
  if (!authInfo) {
    return false
  }
  return new Date(authInfo.expiresOn) > new Date()
}

// -- Types ---------------------------------------------------------
type BlurAuthInfo = {
  expiresOn: string
  accessToken: string
}

type BlurStateType = {
  storageVersion: typeof STORAGE_VERSION
  tokens: Record<Address, BlurAuthInfo | undefined>
}

// -- State ---------------------------------------------------------
const INITIAL_STATE: BlurStateType = {
  storageVersion: STORAGE_VERSION,
  tokens: {},
}

export const BlurState = proxy<BlurStateType>(
  deepClone(restoreStore(STORAGE_KEY, STORAGE_VERSION, INITIAL_STATE)),
)

// -- Actions -------------------------------------------------------
export const BlurActions = {
  setToken(address: Address, authInfo: BlurAuthInfo) {
    BlurState.tokens[address] = authInfo
  },

  clear() {
    BlurState.tokens = {}
  },
}

// -- Subscribe -----------------------------------------------------
subscribe(BlurState, () => {
  persistStore(STORAGE_KEY, BlurState)
})
